import { Injectable } from '@angular/core';
import {AppConfig} from '../app.config';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  public barWeeklyChart = this.config.baseUrl + 'api/charts?type=weekly';
  public lineYearlyChart = this.config.baseUrl + 'api/charts?type=yearly';
  public pieCategoryChart = this.config.baseUrl + 'api/charts?type=category';
  public thisWeekPieCategoryChart = this.config.baseUrl + 'api/charts?type=category&date=this_week';
  public thisMonthPieCategoryChart = this.config.baseUrl + 'api/charts?type=category&date=this_month';
  public thisYearPieCategoryChart = this.config.baseUrl + 'api/charts?type=category&date=this_year';
  constructor(private config: AppConfig,
              private http: HttpClient) { }
  getBarWeeklyChart(): Observable<any>{
    return this.http.get(this.barWeeklyChart, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getLineYearlyChart(): Observable<any>{
    return this.http.get(this.lineYearlyChart, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getPieCategoryChart(): Observable<any>{
    return this.http.get(this.pieCategoryChart, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getWeekPieCategoryChart(): Observable<any>{
    return this.http.get(this.thisWeekPieCategoryChart, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getMonthPieCategoryChart(): Observable<any>{
    return this.http.get(this.thisMonthPieCategoryChart, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getYearPieCategoryChart(): Observable<any>{
    return this.http.get(this.thisYearPieCategoryChart, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
}
